import styled from "styled-components";

export const Container = styled.div`
	gap: 2em;
	//font-size: 1rem;
	font-size: clamp(0.5em, 4.2dvw, 1rem);
	display: flex;
	flex-wrap: wrap;
	margin-top: 2em;
	justify-content: center;
	align-items: center;

	@media (min-width: 650px) {
		font-size: 1rem;
	}
`;
